import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable()
export class GoogleChartsService {
  private readonly scriptSource = 'https://www.gstatic.com/charts/loader.js';
  private onLoadSubject = new Subject<boolean>();
  private doneLoading = false;
  private isLoading = false;

  constructor(@Inject(LOCALE_ID) private localeId: string) {
    this.initialize();
  }

  public get onReady(): Observable<boolean> {
    if (this.doneLoading) {
      return Observable.create(observer => {
        observer.next(true);
        observer.complete();
      });
    }

    return this.onLoadSubject.asObservable();
  }

  public loadChartPackages(packages: Array<string>): Observable<any> {
    return Observable.create(observer => {
      const config = {
        packages: packages,
        language: this.localeId
      };

      google.charts.load('45.2', config);
      google.charts.setOnLoadCallback(() => {
        observer.next();
        observer.complete();
      });
    });
  }

  private initialize() {
    if (!this.doneLoading && !this.isLoading) {
      this.isLoading = true;
      const script = this.createScriptElement();

      script.onload = () => {
        this.doneLoading = true;
        this.isLoading = false;
        this.onLoadSubject.next(true);
        this.onLoadSubject.complete();
      };

      script.onerror = () => {
        this.doneLoading = true;
        this.isLoading = false;
        console.error('Failed to load the google chart script!');
        this.onLoadSubject.error('Failed to load the google chart script!');
        this.onLoadSubject.complete();
      };
    }
  }

  private createScriptElement(): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.scriptSource;
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    return script;
  }
}
